// extracted by mini-css-extract-plugin
export default {"form":"Form_form__2rQ5d","button":"Form_button__srXKB"};